﻿/**
 * 路由配置
 * **/
// 引入vue
import Vue from 'vue';
// 引入vue-router
import VueRouter from 'vue-router';

// 调用，不然要use一下才可以用
Vue.use(VueRouter)

// 引入布局组件
import MainLayout from './components/Layout/MainLayout.vue';

// 引入登录页
import Login from './Pages/Login.vue';

// 数据导入模块
import ImportData from './Pages/Data/ImportData.vue';
import ImportKsxxExcel from './Pages/Data/ImportKsxxExcel.vue';
import ImportPhoto from './Pages/Data/ImportPhoto.vue';
import ImportTjb from './Pages/Data/ImportTjb.vue';

// 数据处理模块
import ManageDict from './Pages/Dict/ManageDict.vue';
import CorrectData from './Pages/Dict/CorrectData.vue';
import ClearData from './Pages/Data/ClearData.vue';

// 数据管理模块
import ListSanBiao from './Pages/Info/ListSanBiao.vue';
import FileManage from './Pages/Info/FileManage.vue';
import StudentList from './Pages/Info/StudentList.vue';

// 录取通知书管理模块
import ExpressList from './Pages/Notice/ExpressList.vue';
import CxtzsEntry from './Pages/Notice/CxtzsEntry.vue';
import NoticeExport from './Pages/Notice/NoticeExport.vue';
import TemplateManage from './Pages/Notice/TemplateManage.vue';

// 数据分析统计模块
import Dashboard from './Pages/Analysis/Dashboard.vue';
import ProvinceAnalysis from './Pages/Analysis/Province.vue';
import MajorAnalysis from './Pages/Analysis/Major.vue';
import ScoreAnalysis from './Pages/Analysis/Score.vue';
import FirstVolunteer from './Pages/Analysis/FirstVolunteer.vue';
import TransferRate from './Pages/Analysis/TransferRate.vue';
import VolunteerComposition from './Pages/Analysis/VolunteerComposition.vue';
import HighSchool from './Pages/Analysis/HighSchool.vue';
import StudentType from './Pages/Analysis/StudentType.vue';
import Ethnicity from './Pages/Analysis/Ethnicity.vue';
import CustomAnalysis from './Pages/Analysis/Custom.vue';
import GenerateReport from './Pages/Analysis/Report.vue';

// 教育调查表模块
import SurveyType from './Pages/Survey/Type.vue';
import SurveyStandard from './Pages/Survey/Standard.vue';
import SurveyMajor from './Pages/Survey/Major.vue';

// 公共数据查询
import ScoreLine from './Pages/Public/ScoreLine.vue';
import AdmissionQuery from './Pages/Public/AdmissionQuery.vue';
import AdmissionResult from './Pages/Public/AdmissionResult.vue';

// 系统管理
import About from './Pages/System/About.vue';

// 定义routes路由的集合，数组类型
const routes = [
    // 登录页（不使用布局）
    { path: '/Login', component: Login, caseSensitive: false },
    
    // 录取查询页面（不使用布局，可直接访问）
    { path: '/Public/AdmissionQuery', component: AdmissionQuery, caseSensitive: false },
    { path: '/Public/AdmissionResult', component: AdmissionResult, caseSensitive: false },
    
    // 使用布局的页面
    {
        path: '/',
        component: MainLayout,
        redirect: '/Info/ListSanBiao',
        children: [
            // 数据导入
            { path: '/Data/ImportData', component: ImportData, caseSensitive: false },
            { path: '/Data/ImportKsxxExcel', component: ImportKsxxExcel, caseSensitive: false },
            { path: '/Data/ImportPhoto', component: ImportPhoto, caseSensitive: false },
            { path: '/Data/ImportTjb', component: ImportTjb, caseSensitive: false },
            
            // 数据处理
            { path: '/Dict/ManageDict', component: ManageDict, caseSensitive: false },
            { path: '/Dict/CorrectData', component: CorrectData, caseSensitive: false },
            { path: '/Dict/ClearData', component: ClearData, caseSensitive: false },
            
            // 数据管理
            { path: '/Info/ListSanBiao', component: ListSanBiao, caseSensitive: false },
            { path: '/Info/FileManage', component: FileManage, caseSensitive: false },
            { path: '/Info/StudentList', component: StudentList, caseSensitive: false },
            
            // 录取通知书管理
            { path: '/Notice/ExpressList', component: ExpressList, caseSensitive: false },
            { path: '/Notice/CxtzsEntry', component: CxtzsEntry, caseSensitive: false },
            { path: '/Notice/NoticeExport', component: NoticeExport, caseSensitive: false },
            { path: '/Notice/TemplateManage', component: TemplateManage, caseSensitive: false },
            
            // 数据分析统计
            { path: '/Analysis/Dashboard', component: Dashboard, caseSensitive: false },
            { path: '/Analysis/Province', component: ProvinceAnalysis, caseSensitive: false },
            { path: '/Analysis/Major', component: MajorAnalysis, caseSensitive: false },
            { path: '/Analysis/Score', component: ScoreAnalysis, caseSensitive: false },
            { path: '/Analysis/FirstVolunteer', component: FirstVolunteer, caseSensitive: false },
            { path: '/Analysis/TransferRate', component: TransferRate, caseSensitive: false },
            { path: '/Analysis/VolunteerComposition', component: VolunteerComposition, caseSensitive: false },
            { path: '/Analysis/HighSchool', component: HighSchool, caseSensitive: false },
            { path: '/Analysis/StudentType', component: StudentType, caseSensitive: false },
            { path: '/Analysis/Ethnicity', component: Ethnicity, caseSensitive: false },
            { path: '/Analysis/Custom', component: CustomAnalysis, caseSensitive: false },
            { path: '/Analysis/Report', component: GenerateReport, caseSensitive: false },
            
            // 教育调查表
            { path: '/Survey/Type', component: SurveyType, caseSensitive: false },
            { path: '/Survey/Standard', component: SurveyStandard, caseSensitive: false },
            { path: '/Survey/Major', component: SurveyMajor, caseSensitive: false },
            
            // 公共数据查询
            { path: '/Public/ScoreLine', component: ScoreLine, caseSensitive: false },
            
            // 系统管理
            { path: '/System/About', component: About, caseSensitive: false }
        ]
    }
]

// 实例化VueRouter，routes配置加进去
const router = new VueRouter({
    // ES6缩写，等同于routes:routes
    routes,
    mode: 'hash' // 使用hash模式
});

// 路由守卫
router.beforeEach((to, from, next) => {
    // 如果是登录页，直接放行
    if (to.path === '/Login') {
        next();
        return;
    }
    
    // 其他页面需要检查登录状态
    // TODO: 实际项目中应该检查session或token
    // const isLoggedIn = sessionStorage.getItem('isLoggedIn');
    // if (!isLoggedIn) {
    //     next('/Login');
    //     return;
    // }
    
    next();
});

// 抛出这个这个实例对象方便外部读取以及访问
export default router
